import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/static/css/global.css";
import "amfe-flexible";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import vshare from 'vshare'

Vue.use(vshare);
Vue.use(ElementUI);

import utils from "@/utils/index.js";
Vue.prototype.$utils = utils;
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
